const getScheduleForRescheduleResponse = (response) => {
  const schedules = response?.schedules?.map((schedule) => {
    return {
      id: schedule?.id,
      value: schedule?.id,
      label: schedule?.label,
      accountLivestream: schedule?.accountLivestream,
      hosts: schedule?.hosts?.map((host) => {
        return {
          ...host,
          label: host.name,
          value: host.id,
        };
      }),
    };
  });

  return schedules;
};

export default getScheduleForRescheduleResponse;
